import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import Document from "../../../../../../common/document/document.component"
import { TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"

export default (): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string[]
        if (value?.length) {
            return value.map((documentId) => (
                <Document key={documentId} documentId={documentId} />
            ))
        } else {
            return "-"
        }
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/FileCellMapper.tsx